// const END_URL = 'https://woolworths-classaction.staging3.dotwibe.com/api/api/';

// const IMG_URL = 'https://woolworths-classaction.staging3.dotwibe.com/api';

const END_URL = 'https://wooliesclassaction.com.au/api/api/';

const IMG_URL = 'https://wooliesclassaction.com.au/api';

// const END_URL = 'https://colespricingclassaction.com.au/api/api/';

// const IMG_URL = 'https://colespricingclassaction.com.au/api';

const RECAPTCHA_SITE_KEY='6LdfNYEsAAAAAEitnMXUSI3mSJzJqu6oby2oMMmr';

export  { END_URL, IMG_URL,RECAPTCHA_SITE_KEY } ;